import type { FC } from 'react';

import Title from '@/components/Title';
import { useHostContext } from '@/context/HostContext';
import ContactForm from '@/pages/CustomerForm/components/ContactForm';
import type { CustomerData } from '@/types/common.ts';
import { cn } from '@/utils';

type TCustomerProp = {
	handleCustomerCreate: (data: CustomerData) => void;
	error?: string;
};

const CustomerForm: FC<TCustomerProp> = ({ error, handleCustomerCreate }) => {
	const { isMiniCreatorMode, isOverlayMode, localization } = useHostContext();

	return (
		<div
			className={cn('h-full block relative', {
				'min-h-0 flex flex-col': isMiniCreatorMode
			})}
		>
			<div
				className={cn('animate-fadeIn flex flex-col gap-[43px] h-full', {
					'gap-2 min-h-0 flex-1': isMiniCreatorMode
				})}
			>
				<Title
					className={cn(
						'intro-title w-full !text-[24px] text-primary-900 !text-left [font-family:var(--font-headlines)] font-semibold m-0',
						{
							'!text-base': isMiniCreatorMode,
							'!text-sm opacity-90 !leading-tight': isMiniCreatorMode,
							'!text-lg !leading-tight': isOverlayMode
						}
					)}
					level={4}
					size="h5"
				>
					{localization.translate('creator', 'customerIdentification.title')}
				</Title>

				<div
					className={cn('relative h-full w-full', {
						'flex-1 min-h-0 overflow-hidden': isMiniCreatorMode
					})}
				>
					<ContactForm
						error={error}
						onSubmit={handleCustomerCreate}
					/>
				</div>
			</div>
		</div>
	);
};

export default CustomerForm;
